import { VolunteerSearchLink, WorldLocation } from "@skv/core";
import * as React from "react";

type LocationSegmentsToReactNode = (
  locations: WorldLocation[],
  isOnlineOrRemote: boolean
) => React.ReactNode;

interface LocationStringsToReactNodeOptions {
  noLocationsText?: string;
  remoteFriendlyLabel?: string;
}

export const locationSegmentsToReactNode: LocationSegmentsToReactNode = (
  locations,
  isOnlineOrRemote,
  options?: LocationStringsToReactNodeOptions
) => {
  options = Object.assign(
    {},
    {
      noLocationsText: "Remote Only",
      remoteFriendlyLabel: "Remote Friendly",
    },
    options
  );

  switch (locations.length) {
    case 0:
      return isOnlineOrRemote ? <span>{options.noLocationsText}</span> : null;
    case 1:
      return (
        <span>
          {locations[0].segments.map((segment, idx) => (
            <React.Fragment key={segment.url + idx}>
              {idx !== 0 && ", "}
              <VolunteerSearchLink
                className="font-weight-normal text-dark"
                to={segment.url}
                searchQuery={{
                  where: segment.value as string,
                }}
                searchType="opp"
              >
                {segment.name}
              </VolunteerSearchLink>
            </React.Fragment>
          ))}
          {isOnlineOrRemote ? ` / ${options.remoteFriendlyLabel}` : null}
        </span>
      );
    default:
      return (
        <span>
          {locations.map((n) => n.displayName).join("; ")}
          {isOnlineOrRemote ? ` / ${options.remoteFriendlyLabel}` : null}
        </span>
      );
  }
};

export const locationStringsToReactNode = (
  locations: string[],
  isOnlineOrRemote: boolean,
  options?: LocationStringsToReactNodeOptions
): React.ReactNode => {
  options = Object.assign(
    {},
    {
      noLocationsText: "Remote Only",
      remoteFriendlyLabel: "Remote Friendly",
    },
    options
  );

  switch (locations.length) {
    case 0:
      return isOnlineOrRemote ? <span>{options.noLocationsText}</span> : null;
    default:
      return (
        <span>
          {locations.join(", ")}
          {isOnlineOrRemote ? ` / ${options.remoteFriendlyLabel}` : null}
        </span>
      );
  }
};
